/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetCompetitionsRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetCompetitionsArgs, useGetCompetitionsSpec, useGetCompetitionsRealtime, useGetCompetitionsPagination } from '../specs/competitions.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetCompetitionsRow } from '../openapi-types.gen.js';
export type { useGetCompetitionsArgs } from '../specs/competitions.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetCompetitionsPaginationContract = useGetCompetitionsPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetCompetitionsInfinite` — both
 * read/write the same `PagedData<GetCompetitionsRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): phase, limit, cursor.
 */
const _useGetCompetitions = createListHook({
  spec: useGetCompetitionsSpec,
  realtime: useGetCompetitionsRealtime,
  entityKey: null,
  pagination: _useGetCompetitionsPaginationContract,
});
export const useGetCompetitions = _useGetCompetitions as (args: useGetCompetitionsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetitions>;


/**
 * Auto-infinite: same cache as `useGetCompetitions`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetCompetitions` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetCompetitionsInfinite = createListHook({
  spec: useGetCompetitionsSpec,
  realtime: useGetCompetitionsRealtime,
  entityKey: null,
  pagination: _useGetCompetitionsPaginationContract,
  autoLoadMore: true,
});
export const useGetCompetitionsInfinite = _useGetCompetitionsInfinite as (args: useGetCompetitionsArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetCompetitionsInfinite>;


/**
 * Per-field subscription hook for the `useGetCompetitions` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetCompetitionsField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetCompetitionsField = createFieldHook<GetCompetitionsRow>('useGetCompetitionsField');

/**
 * Hover/intent prefetch companion for `useGetCompetitions` (also covers
 * `useGetCompetitionsInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetCompetitions();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetCompetitions = createPrefetchHook(useGetCompetitionsSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetCompetitionsArgs>;
